import { render, staticRenderFns } from "./copyWindow.vue?vue&type=template&id=23448dec&"
import script from "./copyWindow.vue?vue&type=script&lang=js&"
export * from "./copyWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23448dec')) {
      api.createRecord('23448dec', component.options)
    } else {
      api.reload('23448dec', component.options)
    }
    module.hot.accept("./copyWindow.vue?vue&type=template&id=23448dec&", function () {
      api.rerender('23448dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/cabinManagement/copyWindow.vue"
export default component.exports